import {css} from "@emotion/react";

//flexbox
export const df = css`
    display: flex;
`;
export const dif = css`
    display: inline-flex;
`;

export const fd_row = css`
    flex-direction: row;
`;
export const fd_col = css`
    flex-direction: column;
`;

export const fw_wrap = css`
    flex-wrap: wrap;
`;
export const fw_nowrap = css`
    flex-wrap: nowrap;
`;

export const fjc_start = css`
    justify-content: flex-start;
`;
export const fjc_center = css`
    justify-content: center;
`;
export const fjc_end = css`
    justify-content: flex-end;
`;
export const fjc_sb = css`
    justify-content: space-between;
`;
export const fjc_sa = css`
    justify-content: space-around;
`;

export const fac_start = css`
    align-content: flex-start;
`;
export const fac_center = css`
    align-content: center;
`;
export const fac_end = css`
    align-content: flex-end;
`;
export const fac_stretch = css`
    align-content: stretch;
`;
export const fac_sb = css`
    align-content: space-between;
`;
export const fac_sa = css`
    align-content: space-around;
`;

export const fai_start = css`
    align-items: flex-start;
`;
export const fai_center = css`
    align-items: center;
`;
export const fai_end = css`
    align-items: flex-end;
`;
export const fai_stretch = css`
    align-items: stretch;
`;
export const fai_baseline = css`
    align-items: baseline;
`;

export const fas_auto = css`
    align-self: auto;
`;
export const fas_start = css`
    align-self: flex-start;
`;
export const fas_center = css`
    align-self: center;
`;
export const fas_end = css`
    align-self: flex-end;
`;
export const fas_stretch = css`
    align-self: stretch;
`;

export const fg_0 = css`
    flex-grow: 0;
`;
export const fg_1 = css`
    flex-grow: 1;
`;

export const fs_0 = css`
    flex-shrink: 0;
`;
export const fs_1 = css`
    flex-shrink: 1;
`;

export const fb_0 = css`
    flex-basis: 0;
`;
export const fb_a = css`
    flex-basis: auto;
`;

export const fo_0 = css`
    order: 0;
`;
export const fo_1 = css`
    order: 1;
`;
export const fo_2 = css`
    order: 2;
`;

export const flex_1 = css`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
`;
export const flex_0 = css`
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 0;
`;

export const flex_centered = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;
